import React from 'react';

const MilestoneDotIcon = () => {
  const className = 'c-MilestoneDotIcon';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <circle
        cx="12"
        cy="12"
        r="11"
        fill="#FBC91B"
        stroke="#FBF0CB"
        strokeWidth="2"
      />
    </svg>
  );
};

export default MilestoneDotIcon;
